import globalActions from "../api/GlobalActions.js"
import globalMutations from "../api/GlobalMutations.js"
import globalGetters from "../api/GlobalGetters.js"

export const state = () => ({
  isStale: true,
  latest_fetch: "",
  type: "dailycfs",
  pageLayout: "StructureTable",
  canEdit: false,
  canView: false,
  effectedByYear: false,
  yearFields: [],
  filterOverrides: ["audits"],
  aliasField: "canalName",
  modelLabels: {
    single: "Daily Canal Flow",
    plural: "Daily Canal Flows"
  },
  relations: [
    {
      name: "canal",
      translate: "canal",
      value: "canals",
      label: "Canal",
      storename: "canals",
      yearFields: [],
      export: true
    }
    // {
    //   name: "maintenanceRequests",
    //   translate: "maintenanceRequests",
    //   value: "maintenanceRequests",
    //   storename: "maintenanceRequests",
    //   yearFields: []
    // },
    // {
    //   name: "owners",
    //   translate: "owners",
    //   value: "owners",
    //   label: "Owners",
    //   storename: "contacts",
    //   yearFields: []
    // },
    // {
    //   name: "producers",
    //   translate: "producers",
    //   value: "producers",
    //   label: "Producers",
    //   storename: "contacts",
    //   yearFields: []
    // }
  ],
  all: {},
  reference: {
    /* for showing paginated resources ... needs a bit more work. */
  },
  active: false,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 150,
    sort: true,
    sortBy: "day",
    page: 1,
    sortDesc: []
  },
  print_path: "",
  search: null,
  searchFields: ["canalName"],
  total: 0,
  print: false,
  export: false,
  bound: {},
  filter: {},
  quickFilters: [],
  stub: {
    canal: {},
    user: {}
  },
  // members are called contractors on the server
  include: "canal",
  headers: {},
  notifications: {}
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
